import { useMutation } from "@tanstack/react-query";

import {
  uploadAvatar,
  uploadSpreadsheet,
  uploadToS3,
} from "../services/upload";

export const useAvatarMutation = () => {
  const upload = useMutation({
    mutationFn: async (payload: FormData) => {
      const response = await uploadAvatar(payload);
      return response;
    },
  });
  return { upload };
};

export const useSpreadsheetMutation = () => {
  const upload = useMutation({
    mutationFn: async (payload: FormData) => {
      const response = await uploadSpreadsheet(payload);
      return response;
    },
  });
  return { upload };
};

export const useS3Mutation = () => {
  const upload = useMutation({
    mutationFn: async (payload: File) => {
      const response = await uploadToS3(payload);
      return response;
    },
  });
  return { upload };
};
